import { render, staticRenderFns } from "./TreasuryTransactionAdd.vue?vue&type=template&id=3a59a02d&scoped=true&"
import script from "./TreasuryTransactionAdd.vue?vue&type=script&lang=js&"
export * from "./TreasuryTransactionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59a02d",
  null
  
)

export default component.exports